import { TeamActionTypes, ApiConfig } from 'app/modules/teamsOld/models';
import { ActionsUnion, createAction } from 'app/shared/utils/action-helpers';
import { CreateTagPayload } from 'app/modules/tags/requests';
import { FullTagResponse } from 'app/modules/tags/responses';

export const retrieveAllTags = () =>
  createAction(TeamActionTypes.RETRIEVE_ALL_TAGS);

export const retrieveAllTagsSuccess = (result: FullTagResponse[]) =>
  createAction(TeamActionTypes.RETRIEVE_ALL_TAGS_SUCCESS, result);

export const clearAddedTag = (tagName: string) =>
  createAction(TeamActionTypes.CLEAR_ADDED_TAG, tagName);

export const addTag = (
  payload: CreateTagPayload,
  handleSuccess?: (result: FullTagResponse) => void,
) => createAction(TeamActionTypes.ADD_TAG, payload, handleSuccess);

export const addTagSuccess = (payload: FullTagResponse) =>
  createAction(TeamActionTypes.ADD_TAG_SUCCESS, payload);

export const retrieveAPIConfigs = () =>
  createAction(TeamActionTypes.RETRIEVE_API_CONFIGS);

export const retrieveAPIConfigsSuccess = (result: ApiConfig) =>
  createAction(TeamActionTypes.RETRIEVE_API_CONFIGS_SUCCESS, result);

// NEW ACTIONS START HERE
export const tagLimitReached = () =>
  createAction(TeamActionTypes.TAG_LIMIT_REACHED);

export const clearTagLimitReached = () =>
  createAction(TeamActionTypes.CLEAR_TAG_LIMIT_REACHED);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const TeamActionsList = {
  retrieveAPIConfigs,
  retrieveAPIConfigsSuccess,
  retrieveAllTags,
  retrieveAllTagsSuccess,
  addTag,
  addTagSuccess,
  clearAddedTag,
  tagLimitReached,
  clearTagLimitReached,
};

export type TeamActions = ActionsUnion<typeof TeamActionsList>;

export default TeamActions;
